import React from 'react'
import { createRoot } from 'react-dom/client'
import { DataProvider } from './context/DataContext'
import ErrorBoundary from './ErrorBoundary'
import App from './App'
import { loadKlapSdk } from './helpers/klapSdk'
import { listenForPushedSessions } from './helpers/session'

listenForPushedSessions()
loadKlapSdk()

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DataProvider>
        <App />
      </DataProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
